import 'angular:locale/data:it';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "it";
